<div class="note_container">
  <span>
    Anyone having this link will be able to join your company.The link will be valid for 30 days and for 1000 people
  </span>
</div>
<div class="btn_container">
  <button a-button class="btn_primary" (click)="onCreateLink()">Create Link</button>
  <button a-button class="btn_secondary" (click)="onCancel()">Cancel</button>
</div>
